import { tEnum } from "@components/i18n";
import { CamelCaseKeys } from "@utils/typescript";
import { UserLess } from "./User";

export enum IngestionStatuses {
  Progressing = 'progressing',
  Success = 'success',
  Error = 'error',
  Done = 'done',
}

export enum IngestionTypes {
  InsurancePolicyUserAdd = 'insurance_policy_user_add',
}

export enum IngestableTypes {
  InsurancePolicy = 'InsurancePolicy',
}

export type Ingestion = CamelCaseKeys<{
  id: number;
  status: IngestionStatuses;
  ingestion_type: IngestionTypes;
  created_at: number;
  successes_count: number;
  errors_count: number;
  skips_count: number;
  data_csv: string;
  result_csv?: string;
  creator: UserLess;
}>;

export const tIngestionStatus = (status: IngestionStatuses) => tEnum('ingestionStatuses', status);
export const tIngestionType = (type: IngestionTypes) => tEnum('ingestionTypes', type);
